import { Block, Inline } from '@contentful/rich-text-types';
import type Context from '@/services/contentful/pageContext';
import Link from '@/services/contentful/contentTypes/Link';
import Media from '@/services/contentful/contentTypes/Media';
import LinkCRC from '@/components-2.0/contentful/Link/Link';
import { Media as MediaCRC } from '@/components/contentful/Media';

interface Props {
    node: Block | Inline;
}

type ValidEmbedTypes = 'Link' | 'Media';

export default function InlineEmbed({ node }: Props) {
    const asset = node.data.target;
    const type: ValidEmbedTypes = asset.sys.contentType?.sys.id;

    if (type === 'Link') {
        const siteLink = Link(asset, {} as Context);
        return <LinkCRC asset={siteLink} />;
    }

    if (type === 'Media') {
        const siteMedia = Media(asset);
        return <MediaCRC asset={siteMedia} />;
    }

    return <></>;
}
